import { render, staticRenderFns } from "./LatestNew.vue?vue&type=template&id=64899ab4&scoped=true"
import script from "./LatestNew.vue?vue&type=script&lang=js"
export * from "./LatestNew.vue?vue&type=script&lang=js"
import style1 from "./LatestNew.vue?vue&type=style&index=1&id=64899ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64899ab4",
  null
  
)

export default component.exports